import { render, staticRenderFns } from "./SessoesPorGeneroIdade.vue?vue&type=template&id=4798ac9b&scoped=true"
import script from "./SessoesPorGeneroIdade.vue?vue&type=script&lang=js"
export * from "./SessoesPorGeneroIdade.vue?vue&type=script&lang=js"
import style0 from "./SessoesPorGeneroIdade.vue?vue&type=style&index=0&id=4798ac9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798ac9b",
  null
  
)

export default component.exports